<template>
  <div class="player_pane2" @click.stop="showPlayerControls()">
    <div
      :class="{
        player_box: true,
        player_box_landscape: window.innerWidth > window.innerHeight
      }"
      :style="{
        height:
          window.innerWidth > window.innerHeight
            ? window.innerHeight + 'px'
            : (videoHeight / videoWidth) * window.innerWidth + 'px'
      }"
    >
      <video
        ref="video"
        :class="{
          media_video: true,
          media_video_landscape: window.innerWidth > window.innerHeight
        }"
        preload="metadata"
        :poster="mediaData.bgImg"
        :src="mediaData.videoUrl"
        webkit-playsinline="true"
        playsinline="true"
        x5-video-player-type="h5-page"
      />
      <!-- <audio ref="audio" :src="mediaData.audioUrl" class="media_audio"></audio> -->

      <VideoPop
        v-if="isShowVideoPop && mediaData.productInfo"
        :product-info="mediaData.productInfo"
      />

      <div v-if="isShowVideoTitle" class="media_video_title">
        {{
          mediaData.productInfo && mediaData.productInfo.firstName
            ? mediaData.productInfo.name
            : '您'
        }}的专属保障方案
      </div>
    </div>

    <div class="player_right_btn">
      <p class="player_right_btn_close" @click.stop="closeVideoPlayer">
        <i class="iconfont icon-close_line" />
      </p>
      <p class="player_right_btn_muted" @click="switchMuted">
        <i
          class="iconfont"
          :class="isMuted ? 'icon-voiceclose' : 'icon-voiceopen'"
        />
      </p>
    </div>
    <VideoControls
      v-if="isShowPlayerControls"
      v-model="precent"
      :playing="playing"
      :current-time-stamp="currentTimeStamp"
      :duration-time-stamp="durationTimeStamp"
      @showPlayerControls="showPlayerControls"
      @switchPlay="switchPlay"
      @input="seek"
      @change="seek"
      @movestart="touchstart"
      @moveing="touchmove"
      @moveend="touchend"
    />
  </div>
</template>

<script>
import { parseTime, orientationChanged } from './components/utils'
import * as CM from 'common/js/common'
import VideoControls from './components/videoControls.vue'
import VideoPop from './components/videoPop.vue'
import { Loading } from 'bxs-ui-vue'
import Jax from '@bxs/jax'

export default {
  name: 'MyVideo2',
  components: {
    [Loading.name]: Loading,
    VideoControls,
    VideoPop
  },
  filters: {},
  mixins: [],
  props: {
    allMediaData: {
      type: Object,
      default() {
        return {}
      }
    },
    productVideo: {
      type: Object,
      default() {
        return {}
      }
    },
    mediaData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isShowPlayerControls: true,
      isShowVideoTitle: false,
      isShowVideoPop: false,
      video: null,
      audio: null,
      videoHeight: 1080,
      videoWidth: 1920,
      isVideoCanplay: false,
      isAudioCanplay: false,
      isTouchMove: false,
      currentVideoTime: 0,
      duration: 0,
      precent: 0,
      playing: false,
      isMuted: false,
      window,
      audioMutedTimer: null,
      controlsTimer: null
    }
  },
  computed: {
    durationTimeStamp() {
      return this.formatTime(this.duration)
    },
    currentTimeStamp() {
      return this.formatTime(this.currentVideoTime)
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.video = this.$refs.video
    //判断是否存在音频链接
    if (this.mediaData.audioUrl) {
      this.audio = this.$refs.audio
    }
    //监听屏幕旋转(可能有兼容问题)
    window.addEventListener(
      'orientationchange',
      () => {
        orientationChanged().then(() => {
          this.$forceUpdate()
        })
      },
      false
    )
    document.addEventListener('visibilitychange', e => {
      if (e.target.hidden) {
        this.switchPlay(false)
      } else {
        setTimeout(() => {
          this.playing = !this.video.paused
        }, 1000)
      }
    })
    this.bindVideoListeners()
    this.bindAudioListeners()
  },
  methods: {
    closeVideoPlayer() {
      window.WeiyiStatSDK.submit(
        Jax.isApp() ? 'sp_a_exit' : 'sp_c_exit',
        this.getVideoMetadata()
      )
      this.switchPlay(false)
      this.$emit('closeVideoPlayer')
      CM.stopBodyScroll(false)
    },
    getVideoMetadata() {
      let { video } = this
      let vMetadata = {
        videoProductId: this.productVideo.productId,
        total_length: this.duration,
        watch_length: 0,
        v: this.productVideo.version + '.0',
        spbb: this.mediaData.key,
        id: this.mediaData.id,
        playing: this.playing
      }
      if (video.played && video.played.length) {
        for (let k = 0; k < video.played.length; k++) {
          vMetadata.watch_length += video.played.end(k) - video.played.start(k)
        }
      }
      localStorage.setItem('PlayingVideoMetadata', JSON.stringify(vMetadata))
      return vMetadata
    },
    showPlayerControls() {
      let self = this
      self.isShowPlayerControls = true
      self.controlsTimer && clearTimeout(self.controlsTimer)
      self.controlsTimer = setTimeout(() => {
        self.isShowPlayerControls = false
      }, 3000)
    },
    bindVideoListeners() {
      let self = this
      //视频元数据是否加载完成。有兼容关题，IOS(测试机 iphone 6p)取不到时长、宽高等数据
      self.video.addEventListener('loadedmetadata', () => {
        self.duration = self.video.duration
        self.videoWidth = self.video.videoWidth
        self.videoHeight = self.video.videoHeight
      })

      //监听视频currentTime值的变化
      self.video.addEventListener('timeupdate', () => {
        if (!self.isTouchMove) {
          self.currentPrecent(self.video.currentTime)
        }
        if (!this.duration) {
          this.duration = self.video.duration
        }
        if (!this.videoWidth) {
          this.videoWidth = self.video.videoWidth
        }
        if (!this.videoHeight) {
          this.videoHeight = self.video.videoHeight
        }
        self.currentVideoTime = self.video.currentTime
        if (self.mediaData.productInfo) {
          self.isShowVideoPop =
            self.currentVideoTime >= self.mediaData.productInfo.startTime &&
            self.currentVideoTime <= self.mediaData.productInfo.endTime
        }
        self.isShowVideoTitle =
          self.currentVideoTime >= 5 &&
          self.currentVideoTime < self.duration - 6 &&
          !self.isShowVideoPop
        self.syncPlayAudio()
        self.getVideoMetadata()
      })

      self.video.addEventListener('canplay', () => {
        self.isVideoCanplay = true
        if (self.audio) {
          self.audio.currentTime = self.video.currentTime
        }
      })

      self.video.addEventListener('ended', () => {
        self.playing = false
        if (this.audio) {
          this.audio.pause()
        }
      })
    },
    setAudioMuted() {
      let self = this
      self.audioMutedTimer = setInterval(() => {
        if (
          self.video &&
          self.audio &&
          self.playing &&
          self.isVideoCanplay &&
          self.isAudioCanplay
        ) {
          self.audio.muted = false
          clearInterval(self.audioMutedTimer)
        } else {
          self.audio.muted = true
        }
      }, 300)
    },
    bindAudioListeners() {
      if (this.audio) {
        this.audio.addEventListener('canplay', () => {
          this.isAudioCanplay = true
        })
      }
    },
    // 用于用户第一次手动触发播放
    startPlay() {
      if (this.video) {
        this.video.play()
      }
      if (this.audio) {
        this.audio.play()
        this.audio.muted = true
        this.setAudioMuted()
      }
      this.playing = true
    },
    // 切换播放状态
    switchPlay(bool) {
      this.playing = bool === undefined ? !this.playing : bool
      if (this.video) {
        this.playing ? this.video.play() : this.video.pause()
      }
      if (this.audio) {
        if (!this.playing) {
          this.audio.pause()
        }
      }
      this.showPlayerControls()
    },
    //音频与视频同步
    syncPlayAudio() {
      if (this.video && this.audio) {
        if (
          this.playing &&
          !this.video.paused &&
          this.audio.currentTime < this.audio.duration
        ) {
          this.audio.play()
        }

        if (
          !this.audio.paused &&
          Math.abs(this.video.currentTime - this.audio.currentTime) > 0.5
        ) {
          this.audio.currentTime = this.video.currentTime
        }
      }
    },
    switchMuted() {
      clearInterval(this.audioMutedTimer)
      this.isMuted = !this.isMuted
      if (this.video && !this.mediaData.audioUrl) {
        this.video.muted = this.isMuted
      }
      if (this.audio) {
        this.audio.muted = this.isMuted
      }
    },
    seek(precent) {
      const t = Math.abs((this.duration * precent) / 100)
      if (this.video) {
        this.video.currentTime = t
      }
      if (this.audio) {
        this.audio.currentTime = t
      }
      this.switchPlay(true)
    },
    touchstart() {
      this.isTouchMove = true
    },
    touchmove() {},
    touchend() {
      this.audio && this.audio.pause()
      this.isTouchMove = false
    },
    formatTime(time) {
      const t = new Date(parseInt(time * 1000, 10))
      const formatter = time >= 60 * 60 ? '{h}:{i}:{s}' : '{i}:{s}'
      return parseTime(t, formatter)
    },
    currentPrecent(currentTime) {
      const diff = Math.floor((currentTime / this.duration) * 10000) / 100
      this.precent = diff
    }
  }
}
</script>

<style>
html {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.player_pane2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  overflow: auto;
  z-index: 10;
  .player_box {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    font-size: 0;
    z-index: 1;
    &.player_box_landscape {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateY(0);
    }
    & .media_video {
      display: block;
      width: 100%;
      height: auto;
      margin: 0 auto;
      vertical-align: top;
      &.media_video_landscape {
        width: auto;
        height: 100%;
      }
    }
    & .media_audio {
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 1px;
      opacity: 0;
      pointer-events: none;
      z-index: 1;
    }
    & .media_video_title {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      display: block;
      margin: 0 auto;
      padding: 10px 4px;
      width: 0.32rem;
      max-height: 80%;
      line-height: 1.2;
      font-size: 12px;
      color: #fff;
      z-index: 3;
      background-color: rgba(125, 113, 250, 0.75);
      border-radius: 2rem;
      box-sizing: content-box;
      text-align: center;
      overflow: hidden;
    }
    & .player_btn_start {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 101%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 4;
      span {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 42px;
        height: 42px;
        border: 3px solid #fff;
        border-radius: 50px;
        color: #fff;
        > i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 24px;
          &.icon-weibiaoti-5-01 {
            left: 55%;
          }
        }
      }
    }
    & .media_video_poster {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      z-index: 3;
    }
  }
  & .player_right_btn {
    position: absolute;
    top: 20px;
    right: 16px;
    width: 30px;
    z-index: 1;
    color: #fff;
    & .player_right_btn_close,
    & .player_right_btn_muted {
      position: relative;
      width: 30px;
      height: 30px;
      margin-bottom: 12px;
      border-radius: 30px;
      background: rgba(255, 255, 255, 0.1);
      > i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 22px;
      }
    }
  }
}
</style>
